import { IOptionProps, IRadioGroupProps, RadioGroup as BPRadioGroup} from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as React from 'react'
import styles from './radio.scss'

const cx = classnames.bind(styles)

interface IProps extends IRadioGroupProps {
  label: string
  name?: string
  options?: IOptionProps[]
  selectedValue: string | number
}

class RadioGroup extends React.Component<IProps> {
  public render() {
    return (
      <BPRadioGroup {...this.props}
        className={cx('radio-group')}
      />
    )
  }
}


export default RadioGroup


// WEBPACK FOOTER //
// ./src/components/Radio/radioGroup.tsx